module.exports = __webpack_public_path__ + "static/img/reliableHome.ccfbff54.jpg";